import React from "react"
import NoContent from "components/elements/NoContent"
import { ModalName } from "sharedTypes"
import useModal from "services/useModal"
import { GUESTS_MANAGEMENT_HELP_LINK } from "utilities/externalLinks"

const NoGuests = () => {
  const showModal = useModal()

  return (
    <NoContent
      title="Guest Management"
      icon="guests-stroke"
      horizontalCTAs
      descriptionItems={[
        <>
          Everything you need to organize and manage your
          <br />
          guests for this event, all in one place.
        </>,
      ]}
      callsToActions={[
        {
          icon: "plus-big",
          text: "Add Guest",
          action: () => showModal(ModalName.NewGuest),
          isButton: true,
        },
        {
          icon: "import",
          text: "Import Guests",
          action: () => showModal(ModalName.ImportGuests),
          isButton: true,
        },
        {
          icon: "book",
          text: "Learn more about Guest Management",
          link: GUESTS_MANAGEMENT_HELP_LINK,
        },
      ]}
    />
  )
}

export default NoGuests
